@let view = data();

<div class="video-content">
  <ui-video-content-player
    [src]="view.src"
    [poster]="view.poster"
    [controls]="view.displayControls"
    [autoplay]="view.autoplay"
    [loop]="view.loop"
    [aspectRatio]="aspectRatio()"
    [maxWidth]="maxWidth()"
  ></ui-video-content-player>
  @if (view.subline) {
    <p>{{ view.subline }}</p>
  }
</div>
